import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { AuthRequest, AuthResponse } from "../../types/types";

const API_LOGIN = process.env.REACT_APP_BASE_URL || "";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({ baseUrl:API_LOGIN }),
  endpoints: (builder) => ({
    login: builder.mutation<AuthResponse, AuthRequest>({
      query: (body) => ({
        url: '/Account/token',
        method: "Post",
        body,
        headers: {
          'AppAgent':'TPFrontEnd'
        }
      }),
    }),
  }),
});

export const { useLoginMutation } = authApi;
